import { writable, type Writable } from 'svelte/store';
import type { SessionDTO, SubscriptionStatus } from './types';

export const session: Writable<SessionDTO | null> = writable(null);

/** Applies a session to the global Svelte store and to body[data-user-status]. */
export function applySession(s: SessionDTO | null): void {
  session.set(s);
  if (typeof document !== 'undefined') {
    if (s) document.body.dataset.userStatus = s.status;
    else delete document.body.dataset.userStatus;
  }
}

export function statusLabel(status: SubscriptionStatus): {
  text: string;
  color: 'green' | 'red' | 'muted';
} {
  switch (status) {
    case 'active':
      return { text: 'Активна', color: 'green' };
    case 'inactive':
      return { text: 'Закінчилась', color: 'red' };
    case 'none':
    default:
      return { text: 'Без підписки', color: 'muted' };
  }
}

/**
 * UI cue helper: returns true when an active subscription is within 5 days of
 * its end date. Used to colour the end-date yellow in profile / banner / admin
 * — it's not a status anymore, just a visual hint.
 */
const EXPIRING_SOON_DAYS = 5;
export function isExpiringSoon(endDate: string | null): boolean {
  if (!endDate) return false;
  const d = new Date(endDate);
  if (Number.isNaN(d.getTime())) return false;
  const daysLeft = (d.getTime() - Date.now()) / 86_400_000;
  return daysLeft >= 0 && daysLeft <= EXPIRING_SOON_DAYS;
}
